import { appDefaultBackground } from 'src/app/dialogs/components/background-color-dialog/background-config';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { ImageTypeEnum } from 'src/app/shared/models/image-type.enum';
import { ScreenDimensions } from 'src/app/shared/models/screen.dimensions.model';
import { ChapterModel } from '../../models/chapter.model';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';

export class RegisterChapterThumbnails {
  static readonly type = '[Story Chapters] Register thumbnail URLs from story';
  constructor(public thumbnails: Map<string, StoryChapterThumbnail>) {}
}

export class TakeChapterPicture {
  static readonly type = '[Story Chapters] Take picture';
  constructor(
    public chapterId: string,
    public background: BackgroundModel = appDefaultBackground,
    public imageType = ImageTypeEnum.JPEG,
    public imageQuality = 0.92,
    public dimensions?: ScreenDimensions,
    public crop: 'original' | 'square' = 'original',
    public includeLabels?: boolean,
    public includeCopyright?: boolean,
    public layers: HTMLCanvasElement[] = [],
  ) {}
}
export class TakeChapterPictureSuccess {
  static readonly type = '[Story Chapters] Take picture success';
  constructor(public chapterId: string, public blob: Blob, public dimensions: ScreenDimensions) {}
}
